import { useNavigate } from "react-router-dom";

export function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer style={{ backgroundColor: "#060d18" }} data-testid="landing-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">

        {/* Firmenname */}
        <p className="text-white font-semibold text-lg">TGAone</p>
        <p className="text-white/40 text-sm mt-1">Montage & Installation von LED-Beleuchtungssystemen</p>

        {/* Kontakt */}
        <div className="mt-8 space-y-2">
          <a href="mailto:info@tgaone.de" className="block text-white/50 hover:text-white transition-colors text-sm">
            info@tgaone.de
          </a>
          <a href="tel:+491723023898" className="block text-white/50 hover:text-white transition-colors text-sm">
            +49 172 3023898
          </a>
        </div>

        {/* Links */}
        <div className="mt-10 flex gap-6 text-xs text-white/25">
          <button onClick={() => navigate("/impressum")} className="hover:text-white/40 transition-colors" data-testid="footer-impressum">
            Impressum
          </button>
          <button onClick={() => navigate("/datenschutz")} className="hover:text-white/40 transition-colors" data-testid="footer-datenschutz">
            Datenschutz
          </button>
          <button onClick={() => navigate("/login")} className="hover:text-white/40 transition-colors" data-testid="footer-login">
            Interner Bereich
          </button>
        </div>

        {/* Copyright */}
        <p className="mt-10 text-white/20 text-xs">&copy; 2026 TGAone</p>

      </div>
    </footer>
  );
}
